// @flow

import React from 'react';
import ClickthroughOrCloseupLink from 'app/common/react/components/PinRep/components/ClickthroughOrCloseupLink';
import smartTruncate from 'app/common/lib/util/smartTruncate';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import TextTransformer from 'app/common/react/components/common/TextTransformer/TextTransformer';
import { type Pin } from 'app/common/react/components/PinRep/types';
import { Avatar, Box } from 'gestalt';

type Props = {|
  pin: Pin,
  showGroupBoardAvatar: boolean,
  singleLineMaxLength: number,
  userNote: string,
|};

const TEXT_LENGTH_RATIO = 1.8; // truncate text to preserve line count w/ avatar

export default function UserNote({
  pin,
  showGroupBoardAvatar,
  singleLineMaxLength,
  userNote,
}: Props) {
  const { pinner } = pin;

  if (!pinner) {
    return null;
  }

  const { full_name: fullName, image_small_url: imageUrl } = pinner;

  const maxLength = TEXT_LENGTH_RATIO * singleLineMaxLength;
  const trimmedUserNote = smartTruncate(userNote, maxLength);

  return (
    <ClickthroughOrCloseupLink pin={pin}>
      <Box alignItems="center" display="flex">
        {!showGroupBoardAvatar && (
          <Box flex="none" marginEnd={2}>
            <Avatar name={fullName} size="sm" src={imageUrl} />
          </Box>
        )}
        <Box data-test-id="PinRep-UserNote">
          <Text overflow="normal" size="sm">
            <TextTransformer
              text={trimmedUserNote}
              options={{ hashtags: { source: 'hashtag_closeup' } }}
            />
          </Text>
        </Box>
      </Box>
    </ClickthroughOrCloseupLink>
  );
}
